import React from "react";

const CreateProfileCardWrapper = ({
  children,
  collapseInnerCard,
  onClick,
  role,
}) => {
  return (
    <>
      <div
        className={`row details-common-card-row ${
          collapseInnerCard ? "card-update" : ""
        }`}
        onClick={onClick}
        role={role}
      >
        <div className="col-12">{children}</div>
      </div>
    </>
  );
};

export default CreateProfileCardWrapper;
